import { IApplicantQuestion } from '../../Components/Utilities/QuestionFieldGenerator';
import { IAnswer } from '../../ApprovalForms/types';

export const getAnswerValue = (
  question: IApplicantQuestion,
  questionIndex: number,
  formResponse: IAnswer[]
) => {
  switch (question.type) {
    case 'RadioButtonField':
    case 'SelectField':
      return formResponse[questionIndex].field_choice_ids.length > 0
        ? formResponse[questionIndex].field_choice_ids[0].toString()
        : {};
    case 'RankField':
      return formResponse[questionIndex].field_choice_ids
        ? formResponse[questionIndex].field_choice_ids.reduce(
            (acc, curr, i) => ({ ...acc, [curr]: (i + 1).toString() }),
            {}
          )
        : {};
    case 'CheckBoxField':
      return formResponse[questionIndex].field_choices.reduce(
        (acc, curr) => {
          acc[curr.id] = formResponse[questionIndex].field_choice_ids.includes(curr.id);
          return acc;
        },
        {} as Record<number, boolean>
      );
    default:
      return formResponse[questionIndex]?.answer;
  }
};
